import React, {Component, forwardRef} from 'react';
import {scroller} from "react-scroll";
import $ from 'jquery';
import {AJAX, close_popup, hidePreloader, show_popup, showPreloader} from "../functions";
import RedirectOnlyHome from "../common/RedirectOnlyHome";
import UploadPhoto from "./UploadPhoto";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";
//import MaskedInput from "react-text-mask/dist/reactTextMask";
//import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe'
import moment from "moment";
import ReactTooltip from "react-tooltip";
import DatePicker from "react-datepicker";

let max_birth_year = moment().subtract(23, 'years').format('YYYY'),
	max_birth_date = new Date(moment().subtract(23, 'years').valueOf()),
	min_birth_year = moment().subtract(73, 'years').format('YYYY'),
	min_birth_date = new Date(moment().subtract(73, 'years').valueOf()),
	min_license_expire_date = new Date(moment().add(5, 'days').valueOf()),
	min_license_expire_year = moment().add(5, 'days').format('YYYY'),
	max_license_expire_year = moment().add(60, 'years').format('YYYY'),
	max_license_expire_date = new Date(moment().add(60, 'years').valueOf());

//const autoCorrectedDatePipe_birth = createAutoCorrectedDatePipe('dd-mm-yyyy', {minYear:min_birth_year, maxYear:max_birth_year});
//const autoCorrectedDatePipe_license = createAutoCorrectedDatePipe('dd-mm-yyyy', {minYear:min_license_expire_year});

const CustomInput = forwardRef(({ value, name, placeholder, onClick }, ref) => (
	<input
		className="form-control datepicker age driver_dob required"
		ref={ref}
		onClick={onClick}
		value={value}
		autoComplete="off"
		type="text"
		readOnly={true}
		style={{cursor: "default", backgroundColor: "#fff"}}
		name={name}
		placeholder={placeholder}
	/>
));
const range = (start, stop, step = 1) => Array(Math.ceil((stop - start) / step)).fill(start).map((x, y) => x + y * step)
const birth_years = range(Number(min_birth_year), Number(max_birth_year) + 1, 1);
const license_years = range(Number(min_license_expire_year), Number(max_license_expire_year) + 1, 1);
const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December",];

class BookingDetailsUpdatePage extends Component {
	constructor(props) {
		super(props);
		this.handleUploadPhoto = this.handleUploadPhoto.bind(this);
		this.onClick = this.onClick.bind(this);
		this.onBlurHandler = this.onBlurHandler.bind(this);
		this.onChangeInput = this.onChangeInput.bind(this);
		this.processExtraDrivers = this.processExtraDrivers.bind(this);

		//console.log(this.props.main_driver.dateofbirth);
		//console.log(moment(this.props.main_driver.dateofbirth, 'DD/MM/YYYY'));


		const formats = ["DD-MM-YYYY", "DD/MM/YYYY", "DD/MMM/YYYY"];

		this.state = {

			is_extradriver: this.props.booking_info.prepared.is_extradriver,

			booking: [
				'additional_driver_fname',
				'additional_driver_lname',
				'additional_driver_email',
				'additional_driver_phone',
				'additional_driver_dob',
				'additional_driver_licenseno',
				'additional_driver_license_country',
				'additional_driver_license_expiry',
				'additional_driver_address',
				'additional_driver_city',
				'additional_driver_state',
				'additional_driver_postcode',
				'additional_driver_customerid'
			],

			driver_license_images: {},

			reset_photo_fields: false,
			main_driver_fnameError: '',
			main_driver_fnameDirty: this.props.main_driver.firstname ? true:false,
			main_driver_lnameError: '',
			main_driver_lnameDirty: this.props.main_driver.lastname ? true:false,

			emailAttempts: 0,

			main_driver_phoneError: '',
			main_driver_phoneDirty: true,
			main_driver_dobError: '',

			main_driver_dobDirty: this.props.main_driver.dateofbirth ?true:false,
			main_driver_licensenoError: '',

			main_driver_licensenoDirty: this.props.main_driver.licenseno?true:false,
			main_driver_license_countryError: '',
			main_driver_license_countryDirty: this.props.main_driver.licenseissued?true:false,
			main_driver_license_expiryError: '',
			main_driver_license_expiryDirty: this.props.main_driver.licenseexpires?true:false,

			main_driver_addressError: '',
			main_driver_addressDirty: this.props.main_driver.address?true:false,
			main_driver_cityError: '',
			main_driver_cityDirty: this.props.main_driver.city?true:false,
			main_driver_stateError: '',
			main_driver_stateDirty: this.props.main_driver.state?true:false,
			main_driver_postcodeError: '',
			main_driver_postcodeDirty: this.props.main_driver.postcode?true:false,

			main_driver_licenseError: 'This field is required.',
			main_driver_licenseDirty: false,
			main_driver_backError: '',
			main_driver_backDirty: true,
			main_driver_selfieError: 'This field is required.',
			main_driver_selfieDirty: false,
			validate: false,

			main_driver: this.props.main_driver,
			additional_drivers: {},

			main_driver_email:this.props.main_driver.email,
			main_driver_emailDirty:this.props.main_driver.email?true:false,
			main_driver_emailError:this.props.main_driver.email?'': 'This field is required.',

			main_driver_fname: this.props.main_driver.firstname,
			main_driver_fnameDisabled: !!this.props.main_driver.firstname,
			main_driver_lname: this.props.main_driver.lastname,
			main_driver_lnameDisabled: !!this.props.main_driver.lastname,
			main_driver_city: this.props.main_driver.city,
			main_driver_cityDisabled: !!this.props.main_driver.city,

			main_driver_state: this.props.main_driver.state,
			main_driver_stateDisabled: !!this.props.main_driver.state,

			main_driver_address: this.props.main_driver.address,
			main_driver_addressDisabled: !!this.props.main_driver.address,

			main_driver_licenseno: this.props.main_driver.licenseno,
			main_driver_licensenoDisabled: !!this.props.main_driver.licenseno,

			main_driver_dob: !!this.props.main_driver.dateofbirth &&  moment(this.props.main_driver.dateofbirth, formats, true).isValid() ? moment(this.props.main_driver.dateofbirth, formats).toDate() : '',
			main_driver_dobDisabled:!!this.props.main_driver.dateofbirth &&  moment(this.props.main_driver.dateofbirth, formats, true).isValid(),

			main_driver_license_expiry: !!this.props.main_driver.licenseexpires &&  moment(this.props.main_driver.licenseexpires, formats, true).isValid() ? moment(this.props.main_driver.licenseexpires, formats).toDate() : '',
			main_driver_license_expiryDisabled: !!this.props.main_driver.licenseexpires &&  moment(this.props.main_driver.licenseexpires, formats, true).isValid(),
			main_driver_postcode: this.props.main_driver.postcode,
			main_driver_postcodeDisabled:!!this.props.main_driver.postcode,
			main_driver_license_country: this.props.main_driver.licenseissued,
			main_driver_license_countryDisabled: !!this.props.main_driver.licenseissued,
			main_driver_license_eLicense:false
		};
	}

	processExtraDrivers(extradrivers) {

		if (!Array.isArray(extradrivers)) {
			return;
		}
		let additionalDrivers = {};
		let newState = {};

		extradrivers.forEach((driver, index) => {

			const formats = ["DD-MM-YYYY", "DD/MM/YYYY", "DD/MMM/YYYY"];

			let d_dob =  moment(driver.dateofbirth, formats, true).isValid() ? moment(driver.dateofbirth, formats).toDate() : '';
			let d_lic  = moment(driver.licenseexpires, formats, true).isValid() ? moment(driver.licenseexpires, formats).toDate() : '';

			const fnameKey = `${index}_additional_driver_fname`;
			const lnameKey = `${index}_additional_driver_lname`;
			const phoneKey = `${index}_additional_driver_phone`;
			const emailKey = `${index}_additional_driver_email`;
			const dobKey = `${index}_additional_driver_dob`;
			const licnoKey = `${index}_additional_driver_licenseno`;
			const liccountryKey = `${index}_additional_driver_license_country`;
			const licexpireKey = `${index}_additional_driver_license_expiry`;
			const addressKey = `${index}_additional_driver_address`;
			const cityKey = `${index}_additional_driver_city`;
			const stateKey = `${index}_additional_driver_state`;
			const postcodeKey = `${index}_additional_driver_postcode`;
			const customerKey = `${index}_additional_driver_customerid`;

			// Update additionalDrivers object
			additionalDrivers[index] = {
				additional_driver_fname: driver.firstname || '',
				additional_driver_lname: driver.lastname || '',
				additional_driver_phone: driver.phone || '',
				additional_driver_email: driver.email || '',
				additional_driver_dob:d_dob || '',
				additional_driver_licenseno:driver.licenseno || '',
				additional_driver_license_country:driver.licenseissued || '',
				additional_driver_license_expiry:d_lic || '',
				additional_driver_address:driver.address || '',
				additional_driver_city:driver.city || '',
				additional_driver_state:driver.state || '',
				additional_driver_postcode:driver.postcode || '',
				additional_driver_customerid:driver.customerid || '',
			};

			// Update new state fields

			newState[fnameKey] = driver.firstname || '';
			newState[fnameKey+'Error'] = driver.firstname? '':'This field is required.';
			newState[fnameKey+'Dirty'] = driver.firstname? true:false;
			newState[fnameKey+'Disabled'] = driver.firstname? true:false;
			newState[lnameKey] = driver.lastname || '';
			newState[lnameKey+'Error'] = driver.lastname? '':'This field is required.';
			newState[lnameKey+'Dirty'] = driver.lastname? true:false;
			newState[lnameKey+'Disabled'] = driver.lastname? true:false;
			newState[phoneKey] = driver.phone || '';
			newState[phoneKey+'Error'] = driver.phone? '':'This field is required.';
			newState[phoneKey+'Dirty'] = driver.phone? true:false;
			newState[phoneKey+'Disabled'] = driver.phone? true:false;
			newState[emailKey] = driver.email || '';
			newState[emailKey+'Error'] = driver.email? '':'This field is required.';
			newState[emailKey+'Dirty'] = driver.email? true:false;
			newState[emailKey+'Disabled'] = driver.email? true:false;
			newState[dobKey] = d_dob || '';
			newState[dobKey+'Error'] = d_dob? '':'This field is required.';
			newState[dobKey+'Dirty'] = d_dob? true:false;
			newState[dobKey+'Disabled'] = d_dob? true:false;
			newState[licnoKey] = driver.licenseno || '';
			newState[licnoKey+'Error'] = driver.licenseno? '':'This field is required.';
			newState[licnoKey+'Dirty'] = driver.licenseno? true:false;
			newState[licnoKey+'Disabled'] = driver.licenseno? true:false;
			newState[liccountryKey] = driver.licenseissued || '';
			newState[liccountryKey+'Error'] = driver.licenseissued? '':'This field is required.';
			newState[liccountryKey+'Dirty'] = driver.licenseissued? true:false;
			newState[liccountryKey+'Disabled'] = driver.licenseissued? true:false;
			newState[licexpireKey] = d_lic || '';
			newState[licexpireKey+'Error'] = d_lic? '':'This field is required.';
			newState[licexpireKey+'Dirty'] = d_lic? true:false;
			newState[licexpireKey+'Disabled'] = d_lic? true:false;

			newState[addressKey] = driver.address || '';
			newState[addressKey+'Error'] = driver.address? '':'This field is required.';
			newState[addressKey+'Dirty'] = driver.address? true:false;
			newState[addressKey+'Disabled'] = driver.address? true:false;

			newState[cityKey] = driver.city || '';
			newState[cityKey+'Error'] = driver.city? '':'This field is required.';
			newState[cityKey+'Dirty'] = driver.city? true:false;
			newState[cityKey+'Disabled'] = driver.city? true:false;

			newState[stateKey] = driver.state || '';
			newState[stateKey+'Error'] = driver.state? '':'This field is required.';
			newState[stateKey+'Dirty'] = driver.state? true:false;
			newState[stateKey+'Disabled'] = driver.state? true:false;

			newState[postcodeKey] = driver.postcode || '';
			newState[postcodeKey+'Error'] = driver.postcode? '':'This field is required.';
			newState[postcodeKey+'Dirty'] = driver.postcode? true:false;
			newState[postcodeKey+'Disabled'] = driver.postcode? true:false;

			newState[customerKey] = driver.customerid || '';
			newState[customerKey+'Error'] = '';
			newState[customerKey+'Dirty'] = true;
			newState[customerKey+'Disabled'] = true;




		});

		// Set state
		this.setState ({
			additional_drivers: additionalDrivers,
			...newState
		});
	}

	componentDidMount() {

		if  ( this.props.booking_info.prepared && this.props.booking_info.prepared.formdata
			&& this.props.booking_info.prepared.formdata.booking_options
			&& this.props.booking_info.prepared.formdata.booking_options.extradriver )
			this.processExtraDrivers(this.props.booking_info.prepared.formdata.booking_options.extradriver);

		if (this.props.scroll_to_element === 'id_drivers_div') {
			scroller.scrollTo( this.props.scroll_to_element, {
				duration: 800,
				smooth: true,
				containerId: "id_scrolling_div"
			})
			this.props.handleSetSomeBlock('scroll_to_element', '');
		}

		let add_booking = [];
		add_booking.push('driver_license', 'driver_back', 'driver_selfie');
		if ( this.props.booking_info.prepared.formdata.booking_options.extradriver
			&& this.props.booking_info.prepared.formdata.booking_options.extradriver.length > 0 ) {
			Object.keys(add_booking).map((item) => {
				for (let i = 0; i < this.props.booking_info.prepared.formdata.booking_options.extradriver.length; i++) {
					this.setState({[ i + '_driver_license_eLicense']:false});
					if (add_booking[item] === 'driver_back') // not required
						this.setState({[i + '_' + add_booking[item] + 'Error']: '', [i + '_' + add_booking[item] + 'Dirty']: true});
					else
						this.setState({
							[i + '_' + add_booking[item] + 'Error']: 'This field is required.',
							[i + '_' + add_booking[item] + 'Dirty']: false
						});
				}
			});

			for (let i = 0; i < this.props.booking_info.prepared.formdata.booking_options.extradriver; i++) {
				this.setState(
					{[i + '_driver_licenseError']: 'This field is required.', [i + '_driver_selfieError']: 'This field is required.'}
				);
			}
		}
	}

	componentDidUpdate(previousProps, prevState) {
		if (this.props.reset_photo_fields && previousProps.reset_photo_fields !== this.props.reset_photo_fields) {
			this.setState({
				driver_license_images: {},
				main_driver_licenseError: 'This field is required.',
				main_driver_licenseDirty: false,
				main_driver_backError: '',
				main_driver_backDirty: true,
				main_driver_selfieError: 'This field is required.',
				main_driver_selfieDirty: false
			});

			let add_booking = [];
			if (this.props.booking_info.prepared.formdata.booking_options.extradriver
				&& this.props.booking_info.prepared.formdata.booking_options.extradriver.length > 0) {
				add_booking.push('driver_license', 'driver_selfie');
				Object.keys(add_booking).map((item) => {
					for (let i = 0; i < this.props.booking_info.prepared.formdata.booking_options.extradriver.length; i++) {
						if (add_booking[item] === 'driver_back') // not required
							this.setState({[i + '_' + add_booking[item] + 'Error']: '', [i + '_' + add_booking[item] + 'Dirty']: true});
						else
							this.setState({[i + '_' + add_booking[item] + 'Error']: 'This field is required.', [i + '_' + add_booking[item] + 'Dirty']: false});
					}
				});
				for (let i = 0; i < this.props.booking_info.prepared.formdata.booking_options.extradriver.length; i++) {
					this.setState({[i + '_driver_licenseError']: 'This field is required.',[i + '_driver_selfieError']: 'This field is required.'});
				}
			}
		}
		/*
		if (prevState.main_driver_license_countryInternational !== this.state.main_driver_license_countryInternational) {
			this.setState({main_driver_stateError: 'This field is required.', main_driver_stateDirty: false});
			this.setState({main_driver_postcodeError: 'This field is required.', main_driver_postcodeDirty: false, main_driver_postcode: ''});
		}
		if ( this.props.booking_info.prepared.formdata.booking_options.extradriver
			&& this.props.booking_info.prepared.formdata.booking_options.extradriver.length > 0) {
			for (let i = 0; i < this.props.booking_info.prepared.formdata.booking_options.extradriver.length; i++) {
				if (prevState[i + '_additional_driver_license_country'] !== this.state[i + '_additional_driver_license_country']) {
					this.setState({[i + '_additional_driver_stateError']: 'This field is required.', [i + '_additional_driver_stateDirty']: false});
					this.setState({[i + '_additional_driver_postcodeError']: 'This field is required.', [i + '_additional_driver_postcodeDirty']: false, [i + '_additional_driver_postcode']: ''});
				}
			}
		}
		*/
	}
	onBlurHandler(e) {
		let name = e.target.name + 'Dirty';
		this.setState({[name]: true});
	}
	onChangeInput(e) {

		let nameError = e.target.name + 'Error';
		let emails_array = ['main_driver_email', 'contact_email'];
		let phone_array = ['main_driver_phone', 'contact_phone'];
		let dob_array = ['main_driver_dob'];
		let lic_exp_array = ['main_driver_license_expiry'];
		let post_array = ['main_driver_postcode'];

		if ( this.props.booking_info.prepared.formdata.booking_options.extradriver &&
			this.props.booking_info.prepared.formdata.booking_options.extradriver.length > 0) {
			for (let i = 0; i < this.props.booking_info.prepared.formdata.booking_options.extradriver.length; i++) {
				emails_array.push(i + '_additional_driver_email');
				phone_array.push(i + '_additional_driver_phone');
				dob_array.push(i + '_additional_driver_dob');
				lic_exp_array.push(i + '_additional_driver_license_expiry');
				post_array.push(i + '_additional_driver_postcode');
			}
		}

		//if (post_array.includes(e.target.name))


		this.setState({[e.target.name]: e.target.value});

		if (e.target.value.length > 0) {

			this.setState({[nameError]: ''});

			if (phone_array.includes(e.target.name)) {
				const re2 = /^(\+6\d{10}|0\d{9})$/;
				if (!re2.test(e.target.value)) {
					this.setState({[nameError]: 'Please enter a valid phone number.'});
				}
			}

			if (emails_array.includes(e.target.name)) {
				const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
				if (!re.test(String(e.target.value).toLowerCase()))
					this.setState({[nameError]: 'Please enter a valid email address.'});
				else  {
					if (e.target.name === 'main_driver_email' ) {
						let emailAttempts = this.state.emailAttempts;
						if ( emailAttempts < 1 && e.target.value !== this.props.main_driver.email ) {
							this.setState((prevState) => ({
								//main_driver_email:'',
								emailAttempts: prevState.emailAttempts + 1,
								[nameError]: 'Email does not match, please try again.'
							}));
						}
					}
				}
			}

			if (dob_array.includes(e.target.name)) {
				let dob = Number(moment(e.target.value, "DD-MM-YYYY").format("YYYY"));
				if (dob > Number(max_birth_year) || dob < Number(min_birth_year))
					this.setState({[nameError]: 'Year of birth must be between '+ min_birth_year + ' and ' + max_birth_year + ' years.'});
			}

			if (lic_exp_array.includes(e.target.name)) {
				let lic_exp = moment(e.target.value, "DD-MM-YYYY");
				if (moment().add(5, 'days').diff(lic_exp,'days') > 0)
					this.setState({[nameError]: 'Date must be after '+ moment().add(5, 'days').format("DD-MM-YYYY") + '.'});
			}

			if ( e.target.name === 'main_driver_postcode') {
				if (e.target.value.replace(/\D/g, '') !== e.target.value || e.target.value.length !== 4)
					this.setState({[nameError]: 'Post Code should only be 4 numbers.'});
			}

			if ( this.props.booking_info.prepared.formdata.booking_options.extradriver
				&& this.props.booking_info.prepared.formdata.booking_options.extradriver.length > 0 ) {
				for (let i = 0; i < this.props.booking_info.prepared.formdata.booking_options.extradriver.length; i++) {
					if ( e.target.name === i + '_additional_driver_postcode') {
						if (e.target.value.replace(/\D/g, '') !== e.target.value || e.target.value.length !== 4)
							this.setState({[nameError]: 'Post Code should only be 4 numbers.'});
					}
				}
			}

		}
		else {
			this.setState({[nameError]: 'This field is required.'});
		}
	}

	handleUploadPhoto( photo_key, url = '', dirty = false, e_license = false ) {
		if (url.length > 0 ) {
			let name = photo_key + 'Error';
			let images = this.state.driver_license_images;

			images[photo_key] = url;

			this.setState({driver_license_images: images, [name]: ''});
		}
		if (dirty) {
			let name = photo_key + 'Dirty';
			this.setState({[name]: dirty});
		}
		let el_name = photo_key + '_eLicense';
		if (e_license) {
			this.setState({[el_name]:true});
		}
		else{
			this.setState({[el_name]:false});
		}
	}

	onClick(e) {

		let booking = this.state.booking;
		let additional_drivers = {};
		let booking_form_data = this.props.booking_form_data;
		let fields = ['main_driver_fname', 'main_driver_lname', 'main_driver_email', 'main_driver_phone', 'main_driver_dob', 'main_driver_licenseno', 'main_driver_license_country', 'main_driver_license_expiry', 'main_driver_address', 'main_driver_city', 'main_driver_state', 'main_driver_postcode'];
		let btn = e.target;
		let form_inputs = $(btn).closest('.drivers');
		let params = {};
		let t = this;

		let validate = true;
		let toSet = {};

		let hire = 0,
			auth = 0,
			total = '$'+this.props.booking_info.prepared.formdata.total;

		if (!this.state.is_extradriver ) {

			Object.keys(fields).map((item) => {
				let el = form_inputs.find('[name='+fields[item]+']');

				if (el.length) {
					booking_form_data['booking[' + fields[item] + ']'] = el[0].value.trim();
				}

				if (this.state[fields[item] + 'Error'] !== '') {
					toSet[fields[item] + 'Dirty'] = true;
					validate = false;
				}
			});

			if (this.state.main_driver_licenseError !== '') {
				toSet.main_driver_licenseDirty = true;
				validate = false;
			}
			if (this.state.main_driver_selfieError !== '') {
				toSet.main_driver_selfieDirty = true;
				validate = false;
			}

			const calc_data = this.props.booking_info.prepared.formdata.email_data.calculation_data;

			Object.keys(calc_data).map((key) => {
				let item = calc_data[key];
				if (item.field === "Total Cost") {
					hire = item.price;
				}
				if (item.field === "Pre-Authorization") {
					auth = item.price;
				}
			});
		}
		else {
			if ( !!this.state.is_extradriver && this.props.booking_info.prepared.formdata.booking_options.extradriver
				&& this.props.booking_info.prepared.formdata.booking_options.extradriver.length > 0) {
				Object.keys(booking).map((item) => {
					let driver_item = {};
					for (let i = 0; i < this.props.booking_info.prepared.formdata.booking_options.extradriver.length; i++) {
						if (this.props.booking_info.prepared.booking.extradriver == (i+1) ) {
							let el = form_inputs.find('[name=' + i + '_' + booking[item] + ']');
							if (el.length) {
								driver_item[i] = el[0].value.trim();
							}
							if (this.state[i + '_' + booking[item] + 'Error'] !== '') {
								toSet[i + '_' + booking[item] + 'Dirty'] = true;
								validate = false;
							}
						}
					}

					additional_drivers[booking[item]] = driver_item;

					for (let i = 0; i < this.props.booking_info.prepared.formdata.booking_options.extradriver.length; i++) {
						if (this.props.booking_info.prepared.booking.extradriver == (i+1) ) {

							if (this.state[i + '_driver_licenseError'] !== '') {
								toSet[i + '_driver_licenseDirty'] = true;
								validate = false;
							}

							if (this.state[i + '_driver_selfieError'] !== '') {
								toSet[i + '_driver_selfieDirty'] = true;
								validate = false;
							}

						}
					}
				});
			}
		}

		toSet.validate = validate;
		this.setState(toSet);

		if (validate) {

			this.setState({additional_drivers: additional_drivers});
			this.props.handleSetBookingDetails(true, booking_form_data.booking, this.state.driver_license_images, additional_drivers);

			if ( !this.state.is_extradriver) {
				this.props.handleSetShowData({
					total_charges:hire,
					total_all: total,
					pre_authorization: auth
				});
				this.props.handleSetPayShow();
				this.props.handleSetSomeBlock('scroll_to_element', 'id_payment_div');
			}
			else {
				const t = this;
				params.action = 'api/booking/confirm-extradriver';
				params.prepared = JSON.stringify(this.props.booking_info.prepared.booking);
				params.drivers = JSON.stringify(additional_drivers);
				params.signature_json = this.props.booking_form_data.signature_json;
				params.signature_png = this.props.booking_form_data.signature_png;

				let ind = this.props.booking_info.prepared.booking.extradriver - 1;


				Object.keys(this.state.driver_license_images).map((k) => {
					params['driver_license_images[' + k + ']'] = this.state.driver_license_images[k];
				});


				AJAX(bm_ajax_url, 'POST', params, {
					response_json: true,
					func_waiting: function () {
						showPreloader();
					},
					func_callback: function (resp) {
						hidePreloader();
						t.props.handleSetThankYouConfirm();
					},
					func_error: function (resp) {
						hidePreloader();
						showPopupWithGoBack(resp.message);
					}
				});
			}
		}
	}

	setDate(name, date) {
		this.setState({[name]: date});
		let nameError = name + 'Error';
		if (date !== '') {
			this.setState({[nameError]: ''});

			let dob_array = ['main_driver_dob'];
			let lic_exp_array = ['main_driver_license_expiry'];
			if ( this.props.booking_info.prepared.formdata.booking_options.extradriver &&
				this.props.booking_info.prepared.formdata.booking_options.extradriver.length > 0) {
				for (let i = 0; i < this.props.booking_info.prepared.formdata.booking_options.extradriver.length; i++) {
					dob_array.push(i + '_additional_driver_dob');
					lic_exp_array.push(i + '_additional_driver_license_expiry');
				}
			}

			if (dob_array.includes(name)) {
				let dob = Number(moment(date, "DD-MM-YYYY").format("YYYY"));
				if (dob > Number(max_birth_year) || dob < Number(min_birth_year))
					this.setState({[nameError]: 'Year of birth must be between '+ min_birth_year + ' and ' + max_birth_year + ' years.'});
			}
			if (lic_exp_array.includes(name)) {
				let lic_exp = moment(date, "DD-MM-YYYY");
				if (moment().add(5, 'days').diff(lic_exp,'days') > 0)
					this.setState({[nameError]: 'Date must be after '+ moment().add(5, 'days').format("DD-MM-YYYY") + '.'});
			}
		}
		else {
			this.setState({[nameError]: 'This field is required.'});
		}
	}

	render() {

		const drivers = [];

		// if (this.state.is_extradriver)
		//	const ext_ind = this.props.booking_info.prepared.booking.extradriver - 1;


		if  (this.props.booking_info.prepared
			&& this.props.booking_info.prepared.formdata
			&& this.props.booking_info.prepared.formdata.booking_options
			&& this.props.booking_info.prepared.formdata.booking_options.extradriver) {
			for (let i = 0; i < this.props.booking_info.prepared.formdata.booking_options.extradriver.length; i++) {
				drivers.push(i);
				//if (this.props.booking_info.prepared.formdata.booking_options.extradriver[i]['files']) {
				//	extrafiles[i] = this.props.booking_info.prepared.formdata.booking_options.extradriver[i]['files'];
				//}
			}
		}


		const license_country_list = [
			'New South Wales',
			'Victoria',
			'Queensland',
			'Tasmania',
			'Northern Territories',
			'Western Australia',
			'South Australia',
			'Australian Capital Territory',
			'International'
		];

		const state_country_list = [
			'New South Wales',
			'Victoria',
			'Queensland',
			'Tasmania',
			'Northern Territories',
			'Western Australia',
			'South Australia',
			'Australian Capital Territory'
		];

		let license_text = "Go With The Gecko collects a driver's license image to verify driver information against the submitted data in the booking request, as well as confirming later against the submitted before and after photos during the vehicle hire period. Your license image should be of the license only, with as little obstruction of the driver's license as possible. An example of a suitable image quality is provided here… <br/><br/><img src='../../wp-content/plugins/booking-form/images/license.png' alt='Upload Driver’s License' className='aligncenter'/>";
		let back_text = "Go With The Gecko collects a driver's license image to verify driver information against the submitted data in the booking request, as well as confirming later against the submitted before and after photos during the vehicle hire period. Your license image should be of the license only, with as little obstruction of the driver's license as possible. An example of a suitable image quality is provided here… <br/><br/><img src='../../wp-content/plugins/booking-form/images/back.jpg' alt='Upload Back of Driver’s License' className='aligncenter'/>";
		let selfie_text = "Go With The Gecko collects a selfie image to verify the driver against the submitted license with the booking request, as well as confirming later against hirer photos submitted during the vehicle hire period. Your selfie should contain you holding the license, with as little obstruction of the driver's license as possible. An example of a suitable image quality is provided here…<br/><br/><img src='../../wp-content/plugins/booking-form/images/selfie.png' alt='Upload Selfie While Holding Driver’s License' className='aligncenter'/>";

		return (<>

			<RedirectOnlyHome />

			<div id={'id_drivers_div'} className={'col drivers'} style={{padding: "20px 30px", marginBottom: "25px"}}>
				<h2 className="fs-title">Booking Details</h2>
				<h3 className="fs-subtitle">Hirer Details</h3>
				<div className="row">

					<div className={'form-group col-md-2 fake-placeholder '+((this.state.main_driver_fnameDirty && this.state.main_driver_fnameError) && 'has-danger')}>
						<div className="placeholder" style={{display: "none"}}>
							<label htmlFor="main_driver_fname">First Name</label>
							<span className="star"> *</span>
						</div>
						<input className="form-control required"
							   type="text" id="main_driver_fname"
							   name="main_driver_fname"
							   placeholder={"First Name *"}
							   onChange={this.onChangeInput}
							   onBlur={this.onBlurHandler}
							   value={ this.state.main_driver_fname}
							   disabled={this.state.main_driver_fnameDisabled }
						/>
						{
							(this.state.main_driver_fnameDirty && this.state.main_driver_fnameError) &&
							<small className="form-control-feedback d-block">{this.state.main_driver_fnameError}</small>
						}
					</div>
					<div className={'form-group col-md-2 fake-placeholder '+((this.state.main_driver_lnameDirty && this.state.main_driver_lnameError) && 'has-danger')}>
						<div className="placeholder" style={{display: "none"}}>
							<label htmlFor="main_driver_lname">Last Name</label>
							<span className="star"> *</span>
						</div>
						<input className="form-control required"
							   type="text" id="main_driver_lname"
							   name="main_driver_lname"
							   placeholder={"Last Name *"}
							   onChange={this.onChangeInput}
							   onBlur={this.onBlurHandler}
							   value={ this.state.main_driver_lname}
							   disabled={this.state.main_driver_lnameDisabled }
						/>
						{
							(this.state.main_driver_lnameDirty && this.state.main_driver_lnameError) &&
							<small className="form-control-feedback d-block">{this.state.main_driver_lnameError}</small>
						}
					</div>
					{ !this.state.is_extradriver &&
						<>
							<div className={'form-group col-md-4 fake-placeholder '+((this.state.main_driver_emailDirty && this.state.main_driver_emailError) && 'has-danger')}>
						<div className="placeholder" style={{display: "none"}}>
							<label htmlFor="main_driver_email">Email</label>
							<span className="star"> *</span>
						</div>
						<input className="form-control required"
							   type="email" id="main_driver_email"
							   name="main_driver_email"
							   placeholder={"Email *"}
							   onChange={this.onChangeInput}
							   onBlur={this.onBlurHandler}
							   value={this.state.main_driver_email}
							   disabled={this.state.is_extradriver}
						/>
						{
							(this.state.main_driver_emailDirty && this.state.main_driver_emailError) &&
							<small className="form-control-feedback d-block">{this.state.main_driver_emailError}</small>
						}
					</div>
							<div className={'form-group col-md-2 fake-placeholder '+((this.state.main_driver_phoneDirty && this.state.main_driver_phoneError) && 'has-danger')}>
						<div className="placeholder" style={{display: "none"}}>
							<label htmlFor="main_driver_phone">Phone</label>
							<span className="star"> *</span>
						</div>
						<input className="form-control required"
							   type="text" id="main_driver_phone"
							   name="main_driver_phone"
							   placeholder={"Phone *"}
							   onChange={this.onChangeInput}
							   onBlur={this.onBlurHandler}
							   value={this.state.main_driver.phone}
							   disabled={true}
						/>
						{
							(this.state.main_driver_phoneDirty && this.state.main_driver_phoneError) &&
							<small className="form-control-feedback d-block">{this.state.main_driver_phoneError}</small>
						}
					</div>
							<div className={'form-group col-md-2 fake-placeholder '+((this.state.main_driver_dobDirty && this.state.main_driver_dobError) && 'has-danger')}>
						<div className="placeholder" style={{display: "none"}}>
							<label>Date of birth</label>
							<span className="star">*</span>
						</div>
						<DatePicker
							renderCustomHeader={({
													 date,
													 changeYear,
													 changeMonth,
													 decreaseMonth,
													 increaseMonth,
													 prevMonthButtonDisabled,
													 nextMonthButtonDisabled,
												 }) => (
								<div style={{margin: 10, display: "flex", justifyContent: "center"}}>
									<button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>{"<"}</button>
									<select value={ date.getFullYear()} onChange={({ target: { value } }) => changeYear(value)} >
										{birth_years.map((option) => (
											<option key={option} value={option}>
												{option}
											</option>
										))}
									</select>

									<select value={months[(date.getMonth())]} onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}>
										{months.map((option) => (
											<option key={option} value={option}>
												{option}
											</option>
										))}
									</select>

									<button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>{">"}</button>
								</div>
							)}
							customInput={<CustomInput />}
							onChange={(date) => this.setDate("main_driver_dob", date)}
							selected={this.state.main_driver_dob}
							disabled={this.state.main_driver_dobDisabled}
							dateFormat="dd-MM-yyyy"
							minDate={min_birth_date}
							maxDate={max_birth_date}
							name={"main_driver_dob"}
							placeholderText={"Date of birth *"}
							startDate={min_birth_date}
							onCalendarOpen={() => {this.setState({main_driver_dobDirty: true});}}
						/>
						{
							(this.state.main_driver_dobDirty && this.state.main_driver_dobError) &&
							<small className="form-control-feedback d-block">{this.state.main_driver_dobError}</small>
						}
					</div>
						</>
					}
				</div>
				{ !this.state.is_extradriver &&
					<>
						<h3 className="fs-subtitle">Additional Details</h3>
						<div className="row">
							<div className={'form-group col-md-3 fake-placeholder '+((this.state.main_driver_licensenoDirty && this.state.main_driver_licensenoError) && 'has-danger')}>

								<div className="placeholder" style={{display: "none"}}>
									<label>License Number</label>
									<span className="star"> *</span>
								</div>
								<input className="form-control required"
									   autoComplete="off" type="text"
									   name="main_driver_licenseno"
									   placeholder={"License Number *"}
									   onChange={this.onChangeInput}
									   /*onChange={(event) =>{this.onChangeInput(event, 'licenseno')}}*/
									   onBlur={this.onBlurHandler}
									   value={ this.state.main_driver_licenseno}
									   disabled={this.state.main_driver_licensenoDisabled }
								/>
								{
									(this.state.main_driver_licensenoDirty && this.state.main_driver_licensenoError) &&
									<small className="form-control-feedback d-block">{this.state.main_driver_licensenoError}</small>
								}
							</div>

							<div className={'form-group col-md-3 '+((this.state.main_driver_license_countryDirty && this.state.main_driver_license_countryError) && 'has-danger')}>
								<select name="main_driver_license_country"
										className="form-control"
										onChange={this.onChangeInput}
										onBlur={this.onBlurHandler}
										value={this.state.main_driver.licenseissued}>
									<option value="" >Select an Issuing Authority *</option>
									{
										license_country_list.map((val) => <option key={val} value={val}>{val}</option>)
									}
								</select>
								{
									(this.state.main_driver_license_countryDirty && this.state.main_driver_license_countryError) &&
									<small className="form-control-feedback d-block">{this.state.main_driver_license_countryError}</small>
								}
							</div>

							<div className={'form-group col-md-3 fake-placeholder'+((this.state.main_driver_license_expiryDirty && this.state.main_driver_license_expiryError) && 'has-danger')}>
								<div className="placeholder" style={{display: "none"}}>
									<label>License Expiry</label>
									<span className="star"> *</span>
								</div>
								<DatePicker
									renderCustomHeader={({
															 date,
															 changeYear,
															 changeMonth,
															 decreaseMonth,
															 increaseMonth,
															 prevMonthButtonDisabled,
															 nextMonthButtonDisabled,
														 }) => (
										<div style={{margin: 10, display: "flex", justifyContent: "center"}}>
											<button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>{"<"}</button>
											<select value={date.getFullYear()} onChange={({ target: { value } }) => changeYear(value)}>
												{license_years.map((option) => (
													<option key={option} value={option}>
														{option}
													</option>
												))}
											</select>

											<select value={months[(date.getMonth())]} onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}>
												{months.map((option) => (
													<option key={option} value={option}>
														{option}
													</option>
												))}
											</select>

											<button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>{">"}</button>
										</div>
									)}
									customInput={<CustomInput />}
									onChange={(date) => this.setDate("main_driver_license_expiry", date)}
									selected={this.state.main_driver_license_expiry}
									disabled={this.state.main_driver_license_expiryDisabled}
									main_driver_licenseno
									dateFormat="dd-MM-yyyy"
									minDate={min_license_expire_date}
									maxDate={max_license_expire_date}
									name={"main_driver_license_expiry"}
									placeholderText={"License Expiry *"}
									startDate={min_license_expire_date}
									onCalendarOpen={() => {this.setState({main_driver_license_expiryDirty: true});}}
								/>
								{/*<MaskedInput
									mask={[ /[0-3]/, /\d/,'-', /[0-1]/, /\d/,'-', /\d/, /\d/, /\d/, /\d/]}
									className="form-control datepicker license required driver_license_expiry"
									guide={true}
									name="main_driver_license_expiry"
									pipe={autoCorrectedDatePipe_license}
									keepCharPositions={true}
									placeholder={"License Expiry *"}
									onChange={this.onChangeInput}
									onBlur={this.onBlurHandler}
								/>*/}
								{
									(this.state.main_driver_license_expiryDirty && this.state.main_driver_license_expiryError) &&
									<small className="form-control-feedback d-block">{this.state.main_driver_license_expiryError}</small>
								}
							</div>
						</div>
						<div className="row">
							{ !this.state.is_extradriver &&
								<div className={'form-group col-md-4 fake-placeholder '+((this.state.main_driver_licenseDirty && this.state.main_driver_licenseError) && 'has-danger')}>
									<div id="main_driver_license_div" className="tooltip-info-div">
										<UploadPhoto
											photo_key={'main_driver_license'}
											photo_type={'license'}
											dirty={this.state.main_driver_licenseDirty}
											error={this.state.main_driver_licenseError}
											handleUploadPhoto={this.handleUploadPhoto}
											reset_photo_fields={this.props.reset_photo_fields}
											handleSetSomeBlock={this.props.handleSetSomeBlock}
										/>
									</div>
									<i className="tooltip-info" data-tip data-for="react_tooltip_license">&nbsp;</i>
									<ReactTooltip
										id="react_tooltip_license"
										place="left"
										effect="solid"
										multiline={true}
										className={'react_tooltip'}
										backgroundColor={'black'}
										html={true}
										scrollHide={true}
										isCapture={true}>
										{license_text}
									</ReactTooltip>
								</div>
							}
							{ !this.state.is_extradriver && !this.state.main_driver_license_eLicense &&
								<div className={'form-group col-md-4 fake-placeholder '+((this.state.main_driver_backDirty && this.state.main_driver_backError) && 'has-danger')}>
									<div id="main_driver_back_div" className="tooltip-info-div">
										<UploadPhoto
											photo_key={'main_driver_back'}
											photo_type={'back'}
											dirty={this.state.main_driver_backDirty}
											error={this.state.main_driver_backError}
											handleUploadPhoto={this.handleUploadPhoto}
											reset_photo_fields={this.props.reset_photo_fields}
											handleSetSomeBlock={this.props.handleSetSomeBlock}
										/>
									</div>
									<i className="tooltip-info" data-tip data-for="react_tooltip_back">&nbsp;</i>
									<ReactTooltip
										id="react_tooltip_back"
										place="left"
										effect="solid"
										multiline={true}
										className={'react_tooltip'}
										backgroundColor={'black'}
										html={true}
										scrollHide={true}
										isCapture={true}>
										{back_text}
									</ReactTooltip>
								</div>
							}
							{ !this.state.is_extradriver &&
								<div className={'form-group col-md-4 fake-placeholder '+((this.state.main_driver_selfieDirty && this.state.main_driver_selfieError) && 'has-danger')}>
									<div id="main_driver_selfie_div" className="tooltip-info-div">
										<UploadPhoto
											photo_key={'main_driver_selfie'}
											photo_type={'selfie'}
											dirty={this.state.main_driver_selfieDirty}
											error={this.state.main_driver_selfieError}
											handleUploadPhoto={this.handleUploadPhoto}
											reset_photo_fields={this.props.reset_photo_fields}
											handleSetSomeBlock={this.props.handleSetSomeBlock}
										/>
									</div>
									<i className="tooltip-info" data-tip data-for="react_tooltip_selfie">&nbsp;</i>
									<ReactTooltip
										id="react_tooltip_selfie"
										place="left"
										effect="solid"
										multiline={true}
										className={'react_tooltip'}
										backgroundColor={'black'}
										html={true}
										scrollHide={true}
										isCapture={true}>
										{selfie_text}
									</ReactTooltip>
								</div>
							}
						</div>
						<div className="row">
							<div className={'form-group col-md-4 fake-placeholder'+((this.state.main_driver_addressDirty && this.state.main_driver_addressError) && 'has-danger')}>
								<div className="placeholder" style={{display: "none"}}>
									<label>Address</label>
									<span className="star"> *</span>
								</div>
								<input className="form-control required"
									   type="text"
									   name="main_driver_address"
									   placeholder={"Address *"}
									   onChange={this.onChangeInput}
									   onBlur={this.onBlurHandler}
									   value={this.state.main_driver_address}
									   disabled={this.state.main_driver_addressDisabled}

								/>
								{
									(this.state.main_driver_addressDirty && this.state.main_driver_addressError) &&
									<small className="form-control-feedback d-block">{this.state.main_driver_addressError}</small>
								}
							</div>
							<div className={'form-group col-md-3 fake-placeholder'+((this.state.main_driver_cityDirty && this.state.main_driver_cityError) && 'has-danger')}>
								<div className="placeholder" style={{display: "none"}}>
									<label>City</label>
									<span className="star"> *</span>
								</div>
								<input className="form-control required"
									   type="text"
									   name="main_driver_city"
									   placeholder={"City *"}
									   onChange={this.onChangeInput}
									   onBlur={this.onBlurHandler}
									   value={this.state.main_driver_city}
									   disabled={this.state.main_driver_cityDisabled}
								/>
								{
									(this.state.main_driver_cityDirty && this.state.main_driver_cityError) &&
									<small className="form-control-feedback d-block">{this.state.main_driver_cityError}</small>
								}
							</div>
							<div className={'form-group col-md-3 fake-placeholder'+((this.state.main_driver_stateDirty && this.state.main_driver_stateError) && 'has-danger')}>
								<div className="placeholder" style={{display: "none"}}>
									<label>State</label>
									<span className="star"> *</span>
								</div>
								{
									(this.state.main_driver_state) ?
										<input className="form-control required"
											   type="text"
											   name="main_driver_state"
											   placeholder={"State *"}
											   onChange={this.onChangeInput}
											   onBlur={this.onBlurHandler}
											   value={this.state.main_driver_state}
											   disabled={this.state.main_driver_stateDisabled}
										/>
									:
										<select name="main_driver_state"
												className="form-control"
												onChange={this.onChangeInput}
												onBlur={this.onBlurHandler}>
											<option value="" >Select a State *</option>
											{
												state_country_list.map((val) => <option key={val} value={val}>{val}</option>)
											}
										</select>
								}
								{
									(this.state.main_driver_stateDirty && this.state.main_driver_stateError) &&
									<small className="form-control-feedback d-block">{this.state.main_driver_stateError}</small>
								}
							</div>
							<div className={'form-group col-md-2 fake-placeholder'+((this.state.main_driver_postcodeDirty && this.state.main_driver_postcodeError) && 'has-danger')}>
								<div className="placeholder" style={{display: "none"}}>
									<label>Postcode</label>
									<span className="star"> *</span>
								</div>
								<input className="form-control required"
									   type="text"
									   name="main_driver_postcode"
									   placeholder={"Postcode *"}
									   onChange={this.onChangeInput}
									   onBlur={this.onBlurHandler}
									   value={this.state.main_driver_postcode}
									   disabled={this.state.main_driver_postcodeDisabled}
								/>
								{
									(this.state.main_driver_postcodeDirty && this.state.main_driver_postcodeError) &&
									<small className="form-control-feedback d-block">{this.state.main_driver_postcodeError}</small>
								}
							</div>
						</div>
					</>
				}

				{
					this.props.booking_info.prepared && this.props.booking_info.prepared.formdata
					&& this.props.booking_info.prepared.formdata.booking_options
					&& this.props.booking_info.prepared.formdata.booking_options.extradriver
					&& this.props.booking_info.prepared.formdata.booking_options.extradriver.length > 0 &&
					Object.keys(drivers).map((v, k) => {

						if ( !this.state.is_extradriver || (this.state.is_extradriver && this.props.booking_info.prepared.booking.extradriver == (drivers[v]+1))) {
							return (
								<div className="additional_drivers" key={drivers[v]}>
									<input type="hidden" name={(drivers[v]) + '_additional_driver_customerid'}/>
									<div className="additional">
										<h2>Additional Driver {drivers[v] + 1}</h2>
										<div className="row">
											<div
												className={'form-group col-md-2 fake-placeholder ' + ((this.state[drivers[v] + '_additional_driver_fnameDirty'] && this.state[drivers[v] + '_additional_driver_fnameError']) && 'has-danger')}>
												<div className="placeholder" style={{display: "none"}}>
													<label>First Name</label>
													<span className="star"> *</span>
												</div>
												<input className="form-control required"
													   type="text"
													   name={(drivers[v]) + '_additional_driver_fname'}
													   placeholder={"First Name *"}
													   onChange={this.onChangeInput}
													   onBlur={this.onBlurHandler}
													   value={this.state[(drivers[v]) + '_additional_driver_fname']}
													   disabled={this.state[(drivers[v]) + '_additional_driver_fnameDisabled']}
												/>
												{
													(this.state[drivers[v] + '_additional_driver_fnameDirty'] && this.state[drivers[v] + '_additional_driver_fnameError']) &&
													<small
														className="form-control-feedback d-block">{this.state[drivers[v] + '_additional_driver_fnameError']}</small>
												}
											</div>

											<div
												className={'form-group col-md-2 fake-placeholder ' + ((this.state[drivers[v] + '_additional_driver_lnameDirty'] && this.state[drivers[v] + '_additional_driver_lnameError']) && 'has-danger')}>
												<div className="placeholder" style={{display: "none"}}>
													<label>Last Name</label>
													<span className="star"> *</span>
												</div>
												<input className="form-control required"
													   type="text"
													   name={(drivers[v]) + '_additional_driver_lname'}
													   placeholder={"Last Name *"}
													   onChange={this.onChangeInput}
													   onBlur={this.onBlurHandler}
													   value={this.state[(drivers[v]) + '_additional_driver_lname']}
													   disabled={this.state[(drivers[v]) + '_additional_driver_lnameDisabled']}
												/>
												{
													(this.state[drivers[v] + '_additional_driver_lnameDirty'] && this.state[drivers[v] + '_additional_driver_lnameError']) &&
													<small
														className="form-control-feedback d-block">{this.state[drivers[v] + '_additional_driver_lnameError']}</small>
												}
											</div>

											<div
												className={'form-group col-md-4 fake-placeholder ' + ((this.state[drivers[v] + '_additional_driver_emailDirty'] && this.state[drivers[v] + '_additional_driver_emailError']) && 'has-danger')}>
												<div className="placeholder" style={{display: "none"}}>
													<label>Email</label>
													<span className="star"> *</span>
												</div>
												<input className="form-control required"
													   type="email"
													   name={(drivers[v]) + '_additional_driver_email'}
													   placeholder={"Email *"}
													   onChange={this.onChangeInput}
													   onBlur={this.onBlurHandler}
													   value={this.state[(drivers[v]) + '_additional_driver_email']}
													   disabled={this.state[(drivers[v]) + '_additional_driver_emailDisabled']}
												/>
												{
													(this.state[drivers[v] + '_additional_driver_emailDirty'] && this.state[drivers[v] + '_additional_driver_emailError']) &&
													<small
														className="form-control-feedback d-block">{this.state[drivers[v] + '_additional_driver_emailError']}</small>
												}
											</div>

											<div
												className={'form-group col-md-2 fake-placeholder ' + ((this.state[drivers[v] + '_additional_driver_phoneDirty'] && this.state[drivers[v] + '_additional_driver_phoneError']) && 'has-danger')}>
												<div className="placeholder" style={{display: "none"}}>
													<label>Phone</label>
													<span className="star"> *</span>
												</div>
												<input className="form-control required"
													   type="text"
													   name={(drivers[v]) + '_additional_driver_phone'}
													   placeholder={"Phone *"}
													   onChange={this.onChangeInput}
													   onBlur={this.onBlurHandler}
													   value={this.state[(drivers[v]) + '_additional_driver_phone']}
													   disabled={!!this.state[(drivers[v]) + '_additional_driver_phoneDisabled']}
												/>
												{
													(this.state[drivers[v] + '_additional_driver_phoneDirty'] && this.state[drivers[v] + '_additional_driver_phoneError']) &&
													<small
														className="form-control-feedback d-block">{this.state[drivers[v] + '_additional_driver_phoneError']}</small>
												}
											</div>

											<div
												className={'form-group col-md-2 fake-placeholder ' + ((this.state[drivers[v] + '_additional_driver_dobDirty'] && this.state[drivers[v] + '_additional_driver_dobError']) && 'has-danger')}>
												<div className="placeholder" style={{display: "none"}}>
													<label>Date of birth</label>
													<span className="star"> *</span>
												</div>
												<DatePicker
													renderCustomHeader={({
																			 date,
																			 changeYear,
																			 changeMonth,
																			 decreaseMonth,
																			 increaseMonth,
																			 prevMonthButtonDisabled,
																			 nextMonthButtonDisabled,
																		 }) => (
														<div style={{
															margin: 10,
															display: "flex",
															justifyContent: "center"
														}}>
															<button onClick={decreaseMonth}
																	disabled={prevMonthButtonDisabled}>{"<"}</button>
															<select value={date.getFullYear()}
																	onChange={({target: {value}}) => changeYear(value)}>
																{birth_years.map((option) => (
																	<option key={option} value={option}>
																		{option}
																	</option>
																))}
															</select>

															<select value={months[(date.getMonth())]}
																	onChange={({target: {value}}) => changeMonth(months.indexOf(value))}>
																{months.map((option) => (
																	<option key={option} value={option}>
																		{option}
																	</option>
																))}
															</select>

															<button onClick={increaseMonth}
																	disabled={nextMonthButtonDisabled}>{">"}</button>
														</div>
													)}
													customInput={<CustomInput/>}
													onChange={(date) => this.setDate((drivers[v]) + '_additional_driver_dob', date)}
													selected={this.state[(drivers[v]) + '_additional_driver_dob']}
													disabled={!!this.state[(drivers[v]) + '_additional_driver_dobDisabled']}
													dateFormat="dd-MM-yyyy"
													minDate={min_birth_date}
													maxDate={max_birth_date}
													name={(drivers[v]) + '_additional_driver_dob'}
													placeholderText={"Date of birth *"}
													startDate={min_birth_date}
													onCalendarOpen={() => {
														this.setState({[(drivers[v]) + '_additional_driver_dobDirty']: true});
													}}

												/>
												{
													(this.state[drivers[v] + '_additional_driver_dobDirty'] && this.state[drivers[v] + '_additional_driver_dobError']) &&
													<small
														className="form-control-feedback d-block">{this.state[drivers[v] + '_additional_driver_dobError']}</small>
												}
											</div>
										</div>
										<div className="row">
											<div
												className={'form-group col-md-3 fake-placeholder ' + ((this.state[drivers[v] + '_additional_driver_licensenoDirty'] && this.state[drivers[v] + '_additional_driver_licensenoError']) && 'has-danger')}>
												<div className="placeholder" style={{display: "none"}}>
													<label>License Number</label>
													<span className="star"> *</span>
												</div>
												<input className="form-control required"
													   autoComplete="off" type="text"
													   name={(drivers[v]) + '_additional_driver_licenseno'}
													   placeholder={"License Number *"}
													   onChange={this.onChangeInput}
													   onBlur={this.onBlurHandler}
													   value={this.state[(drivers[v]) + '_additional_driver_licenseno']}
													   disabled={this.state[(drivers[v]) + '_additional_driver_licensenoDisabled']}
												/>
												{
													(this.state[drivers[v] + '_additional_driver_licensenoDirty'] && this.state[drivers[v] + '_additional_driver_licensenoError']) &&
													<small
														className="form-control-feedback d-block">{this.state[drivers[v] + '_additional_driver_licensenoError']}</small>
												}
											</div>

											<div
												className={'form-group col-md-3 fake-placeholder ' + ((this.state[drivers[v] + '_additional_driver_license_countryDirty'] && this.state[drivers[v] + '_additional_driver_license_countryError']) && 'has-danger')}>

												{
													(this.state.main_driver_state) ?
														<input className="form-control required"
															   type="text"
															   name={(drivers[v]) + '_additional_driver_license_country'}
															   placeholder={"State *"}
															   onChange={this.onChangeInput}
															   onBlur={this.onBlurHandler}
															   value={this.state[(drivers[v]) + '_additional_driver_license_country']}
															   disabled={this.state[(drivers[v]) + '_additional_driver_license_countryDisabled']}
														/>
														:
														<select
															name={(drivers[v]) + '_additional_driver_license_country'}
															className="form-control"

															onChange={this.onChangeInput}

															onBlur={this.onBlurHandler}
															selected={this.state[(drivers[v]) + '_additional_driver_license_country']}

															disabled={!!this.state[(drivers[v]) + '_additional_driver_license_countryDisabled']}>

															<option value="">Select an Issuing Authority *</option>
															{
																license_country_list.map((val) => <option key={val}
																										  value={val}> {val} </option>)
															}

														</select>
												}
												{
													(this.state[drivers[v] + '_additional_driver_license_countryDirty'] && this.state[drivers[v] + '_additional_driver_license_countryError']) &&
													<small
														className="form-control-feedback d-block">{this.state[drivers[v] + '_additional_driver_license_countryError']}</small>
												}
											</div>

											<div
												className={'form-group col-md-3 fake-placeholder ' + ((this.state[drivers[v] + '_additional_driver_license_expiryDirty'] && this.state[drivers[v] + '_additional_driver_license_expiryError']) && 'has-danger')}>
												<div className="placeholder" style={{display: "none"}}>
													<label>License Expiry</label>
													<span className="star"> *</span>
												</div>
												<DatePicker
													renderCustomHeader={({
																			 date,
																			 changeYear,
																			 changeMonth,
																			 decreaseMonth,
																			 increaseMonth,
																			 prevMonthButtonDisabled,
																			 nextMonthButtonDisabled,
																		 }) => (
														<div style={{
															margin: 10,
															display: "flex",
															justifyContent: "center"
														}}>
															<button onClick={decreaseMonth}
																	disabled={prevMonthButtonDisabled}>{"<"}</button>
															<select value={date.getFullYear()}
																	onChange={({target: {value}}) => changeYear(value)}>
																{license_years.map((option) => (
																	<option key={option} value={option}>
																		{option}
																	</option>
																))}
															</select>

															<select value={months[(date.getMonth())]}
																	onChange={({target: {value}}) => changeMonth(months.indexOf(value))}>
																{months.map((option) => (
																	<option key={option} value={option}>
																		{option}
																	</option>
																))}
															</select>

															<button onClick={increaseMonth}
																	disabled={nextMonthButtonDisabled}>{">"}</button>
														</div>
													)}
													customInput={<CustomInput/>}
													onChange={(date) => this.setDate((drivers[v]) + '_additional_driver_license_expiry', date)}
													selected={this.state[(drivers[v]) + '_additional_driver_license_expiry']}
													disabled={this.state[(drivers[v]) + '_additional_driver_license_expiryDisabled']}
													dateFormat="dd-MM-yyyy"
													minDate={min_license_expire_date}
													maxDate={max_license_expire_date}
													name={(drivers[v]) + '_additional_driver_license_expiry'}
													placeholderText={"License Expiry *"}
													startDate={min_license_expire_date}
													onCalendarOpen={() => {
														this.setState({[(drivers[v]) + '_additional_driver_license_expiryDirty']: true});
													}}
												/>
												{
													(this.state[drivers[v] + '_additional_driver_license_expiryDirty'] && this.state[drivers[v] + '_additional_driver_license_expiryError']) &&
													<small
														className="form-control-feedback d-block">{this.state[drivers[v] + '_additional_driver_license_expiryError']}</small>
												}
											</div>

										</div>
										<div className="row">
											{this.state.is_extradriver && this.props.booking_info.prepared.booking.extradriver == (drivers[v] + 1) &&
												<div
													className={'form-group col-md-4 fake-placeholder ' + ((this.state[drivers[v] + '_driver_licenseDirty'] && this.state[drivers[v] + '_driver_licenseError']) && 'has-danger')}>
													<div id={(drivers[v]) + '_driver_license_div'}
														 className="tooltip-info-div">
														<UploadPhoto
															photo_key={(drivers[v]) + '_driver_license'}
															photo_type={'license'}
															dirty={this.state[drivers[v] + '_driver_licenseDirty']}
															error={this.state[drivers[v] + '_driver_licenseError']}
															handleUploadPhoto={this.handleUploadPhoto}
															reset_photo_fields={this.props.reset_photo_fields}
															handleSetSomeBlock={this.props.handleSetSomeBlock}
														/>
													</div>
													<i className="tooltip-info" data-tip
													   data-for={'react_tooltip_license_' + (drivers[v])}>&nbsp;</i>
													<ReactTooltip
														id={'react_tooltip_license_' + (drivers[v])}
														place="left"
														effect="solid"
														multiline={true}
														className={'react_tooltip'}
														backgroundColor={'black'}
														html={true}
														scrollHide={true}
														isCapture={true}>
														{license_text}
													</ReactTooltip>
												</div>
											}
											{this.state.is_extradriver && this.props.booking_info.prepared.booking.extradriver == (drivers[v] + 1) && !this.state[drivers[v] + '_driver_license_eLicense'] &&
												<div
													className={'form-group col-md-4 fake-placeholder ' + ((this.state[drivers[v] + '_driver_backDirty'] && this.state[drivers[v] + '_driver_backError']) && 'has-danger')}>
													<div id={(drivers[v]) + '_driver_back_div'}
														 className="tooltip-info-div">
														<UploadPhoto
															photo_key={(drivers[v]) + '_driver_back'}
															photo_type={'back'}
															dirty={this.state[drivers[v] + '_driver_backDirty']}
															error={this.state[drivers[v] + '_driver_backError']}
															handleUploadPhoto={this.handleUploadPhoto}
															reset_photo_fields={this.props.reset_photo_fields}
															handleSetSomeBlock={this.props.handleSetSomeBlock}
														/>
													</div>
													<i className="tooltip-info" data-tip
													   data-for={'react_tooltip_back_' + (drivers[v])}>&nbsp;</i>
													<ReactTooltip
														id={'react_tooltip_back_' + (drivers[v])}
														place="left"
														effect="solid"
														multiline={true}
														className={'react_tooltip'}
														backgroundColor={'black'}
														html={true}
														scrollHide={true}
														isCapture={true}>
														{back_text}
													</ReactTooltip>
												</div>
											}
											{this.state.is_extradriver && this.props.booking_info.prepared.booking.extradriver == (drivers[v] + 1) &&
												<div
													className={'form-group col-md-4 fake-placeholder ' + ((this.state[drivers[v] + '_driver_selfieDirty'] && this.state[drivers[v] + '_driver_selfieError']) && 'has-danger')}>
													<div id={(drivers[v]) + '_driver_selfie_div'}
														 className="tooltip-info-div">
														<UploadPhoto
															photo_key={(drivers[v]) + '_driver_selfie'}
															photo_type={'selfie'}
															dirty={this.state[drivers[v] + '_driver_selfieDirty']}
															error={this.state[drivers[v] + '_driver_selfieError']}
															handleUploadPhoto={this.handleUploadPhoto}
															reset_photo_fields={this.props.reset_photo_fields}
															handleSetSomeBlock={this.props.handleSetSomeBlock}
														/>
													</div>
													<i className="tooltip-info" data-tip
													   data-for={'react_tooltip_selfie_' + (drivers[v])}>&nbsp;</i>
													<ReactTooltip
														id={'react_tooltip_selfie_' + (drivers[v])}
														place="left"
														effect="solid"
														multiline={true}
														className={'react_tooltip'}
														backgroundColor={'black'}
														html={true}
														scrollHide={true}
														isCapture={true}>
														{selfie_text}
													</ReactTooltip>
												</div>
											}
											{ /* !this.state.is_extradriver  && extrafiles && extrafiles[v] &&

												<div>
													<input
														type = 'hidden'
														value={
															extrafiles[v]['additional_driver_license_image'][v]['url'] + '|' +
															extrafiles[v]['additional_driver_license_image'][v]['size'] + '|' +
															extrafiles[v]['additional_driver_license_image'][v]['type'] + '|' +
															extrafiles[v]['additional_driver_license_image'][v]['doctype']
														}
														name={'driver_license_images[' + (drivers[v])+'_driver_license]'}
													/>
													<input
														type = 'hidden'
														value={
															extrafiles[v]['additional_driver_back_image'][v]['url'] + '|' +
															extrafiles[v]['additional_driver_back_image'][v]['size'] + '|' +
															extrafiles[v]['additional_driver_back_image'][v]['type'] + '|' +
															extrafiles[v]['additional_driver_back_image'][v]['doctype']
														}
														name={'driver_license_images[' + (drivers[v])+'_driver_back]'}
													/>
													<input
														type = 'hidden'
														value={
															extrafiles[v]['additional_driver_selfie_image'][v]['url'] + '|' +
															extrafiles[v]['additional_driver_selfie_image'][v]['size'] + '|' +
															extrafiles[v]['additional_driver_selfie_image'][v]['type'] + '|' +
															extrafiles[v]['additional_driver_selfie_image'][v]['doctype']
														}
														name={'driver_license_images[' + (drivers[v])+'_driver_selfie]'}
													/>
												</div>
										*/}


										</div>
									</div>
									<div className="row">
										<div
											className={'form-group col-md-4 fake-placeholder ' + ((this.state[drivers[v] + '_additional_driver_addressDirty'] && this.state[drivers[v] + '_additional_driver_addressError']) && 'has-danger')}>
											<div className="placeholder" style={{display: "none"}}>
												<label>Address</label>
												<span className="star"> *</span>
											</div>
											<input className="form-control required"
												   type="text"
												   name={(drivers[v]) + '_additional_driver_address'}
												   placeholder={"Address *"}
												   onChange={this.onChangeInput}
												   onBlur={this.onBlurHandler}

												   value={this.state[(drivers[v]) + '_additional_driver_address']}
												   disabled={!!this.state[(drivers[v]) + '_additional_driver_addressDisabled']}

											/>
											{
												(this.state[drivers[v] + '_additional_driver_addressDirty'] && this.state[drivers[v] + '_additional_driver_addressError']) &&
												<small
													className="form-control-feedback d-block">{this.state[drivers[v] + '_additional_driver_addressError']}</small>
											}
										</div>
										<div
											className={'form-group col-md-3 fake-placeholder ' + ((this.state[drivers[v] + '_additional_driver_cityDirty'] && this.state[drivers[v] + '_additional_driver_cityError']) && 'has-danger')}>
											<div className="placeholder" style={{display: "none"}}>
												<label>City</label>
												<span className="star"> *</span>
											</div>
											<input className="form-control required"
												   type="text"
												   name={(drivers[v]) + '_additional_driver_city'}
												   placeholder={"City *"}
												   onChange={this.onChangeInput}
												   onBlur={this.onBlurHandler}
												   value={this.state[(drivers[v]) + '_additional_driver_city']}
												   disabled={!!this.state[(drivers[v]) + '_additional_driver_cityDisabled']}
											/>
											{
												(this.state[drivers[v] + '_additional_driver_cityDirty'] && this.state[drivers[v] + '_additional_driver_cityError']) &&
												<small
													className="form-control-feedback d-block">{this.state[drivers[v] + '_additional_driver_cityError']}</small>
											}
										</div>
										<div
											className={'form-group col-md-3 fake-placeholder ' + ((this.state[drivers[v] + '_additional_driver_stateDirty'] && this.state[drivers[v] + '_additional_driver_stateError']) && 'has-danger')}>
											<div className="placeholder" style={{display: "none"}}>
												<label>State</label>
												<span className="star"> *</span>
											</div>
											{
												(this.state[(drivers[v]) + '_additional_driver_state']) ?
													<input className="form-control required"
														   type="text"
														   name={(drivers[v]) + '_additional_driver_state'}
														   placeholder={"State *"}
														   onChange={this.onChangeInput}
														   onBlur={this.onBlurHandler}
														   value={this.state[(drivers[v]) + '_additional_driver_state']}
														   disabled={!!this.state[(drivers[v]) + '_additional_driver_stateDisabled']}
													/>
													:
													<select name={(drivers[v]) + '_additional_driver_state'}
															className="form-control"
															onChange={this.onChangeInput}
															onBlur={this.onBlurHandler}
															value={this.state[(drivers[v]) + '_additional_driver_state']}
															disabled={!!this.state[(drivers[v]) + '_additional_driver_stateDisabled']}>
														<option value="">Select a State *</option>
														{
															state_country_list.map((val) => <option key={val}
																									value={val}>{val}</option>)
														}
													</select>
											}
											{
												(this.state[drivers[v] + '_additional_driver_stateDirty'] && this.state[drivers[v] + '_additional_driver_stateError']) &&
												<small
													className="form-control-feedback d-block">{this.state[drivers[v] + '_additional_driver_stateError']}</small>
											}
										</div>
										<div
											className={'form-group col-md-2 fake-placeholder ' + ((this.state[drivers[v] + '_additional_driver_postcodeDirty'] && this.state[drivers[v] + '_additional_driver_postcodeError']) && 'has-danger')}>
											<div className="placeholder" style={{display: "none"}}>
												<label>Postcode</label>
												<span className="star"> *</span>
											</div>
											<input className="form-control required"
												   name={(drivers[v]) + '_additional_driver_postcode'}
												   placeholder={"Postcode *"}
												   onChange={this.onChangeInput}
												   onBlur={this.onBlurHandler}
												   value={this.state[(drivers[v]) + '_additional_driver_postcode']}
												   disabled={!!this.state[(drivers[v]) + '_additional_driver_postcodeDisabled']}
											/>
											{
												(this.state[drivers[v] + '_additional_driver_postcodeDirty'] && this.state[drivers[v] + '_additional_driver_postcodeError']) &&
												<small
													className="form-control-feedback d-block">{this.state[drivers[v] + '_additional_driver_postcodeError']}</small>
											}
										</div>
									</div>
								</div>
							)
						}
						else {
							return null;
						}
					})
				}
				<div className="row hire-cost">
					<div className="form-group col">
						<input type="button" className="btn btn-success" value={ this.state.is_extradriver ? 'Confirm' : 'Proceed With Payment'} onClick={this.onClick} />
					</div>
				</div>
			</div>
		</>);
	}

}

export default BookingDetailsUpdatePage;